import { render } from "./PortfolioPreview.vue?vue&type=template&id=9ebe743e&scoped=true"
import script from "./PortfolioPreview.vue?vue&type=script&lang=js"
export * from "./PortfolioPreview.vue?vue&type=script&lang=js"

import "./PortfolioPreview.vue?vue&type=style&index=0&id=9ebe743e&scoped=true&lang=css"
script.render = render
script.__scopeId = "data-v-9ebe743e"

export default script